import React from "react";
import PropTypes from "prop-types";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";

const EmptyCard = ({message}) => {
  let txt = message ? message : "Empty.  No text has been entered.";
  return (
      <Card key="empty" className="md-block-centered" style={{width: "100%"}} >
          <CardText>
              <div>{txt}</div>
          </CardText>
      </Card>
  );
};

EmptyCard.propTypes = {
    message: PropTypes.string
};
export {
  EmptyCard
};